import { CustomValidators } from 'src/app/shared/helpers/custom-validators';
import { LoginService } from 'src/app/core/services/login.service';
import { Component, Input, OnInit, AfterViewInit, Output, EventEmitter, SimpleChange, inject } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Entity } from 'src/app/core/models/entity.model';
import { HorizonsTeam } from 'src/app/core/models/horizons-team.model';
import { Team } from 'src/app/core/models/team.model';
import { User } from 'src/app/core/models/user.model';
import { UserService } from 'src/app/core/services/user.service';
import { EntityService } from 'src/app/core/services/entity.service';
import * as utils from 'src/app/shared/helpers/utils';
import { map, Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { ConfigService } from 'src/app/core/services/config.service';
import { TeamScopeService } from 'src/app/core/services/team-scope.service';

@Component({
  selector: 'hbo-user-actions',
  templateUrl: './user-actions.component.html',
  styleUrls: ['./user-actions.component.scss']
})
export class UserActionsComponent implements OnInit, AfterViewInit {

  @Input() user!: User;
  @Output() reload: EventEmitter<any> = new EventEmitter();

  currentUser: User = utils.localStorageGetItem('user');

  action = 'create';

  entityId: FormControl<number | null> = new FormControl(null);
  teamId: FormControl<number | null> = new FormControl(0);
  horizonsTeamId: FormControl<number | null> = new FormControl(0);
  head_office_herency_team!: string | null;
  teamIds: FormControl<number[]> = new FormControl<number[]>([], { nonNullable: true });

  userForm = this.formBuilder.nonNullable.group({
    id: [''],
    fullname: ['', Validators.required],
    email: ['', [Validators.required, CustomValidators.lowercaseEmailValidator]],
    username: ['', [Validators.required, CustomValidators.usernameValidator]],
    entityId: this.entityId,
    roleId: [''],
    profileId: ['1', Validators.required],
    teamId: this.teamId,
    teamIds: this.teamIds,
    horizonsTeamId: this.horizonsTeamId
  });

  entities: Entity[] = [];
  teams: Team[] = [];
  partialTeams: Team[] = [];

  private readonly teamScope = inject(TeamScopeService);

  private assignableTeamsSource: Team[] | null = null;
  private assignableTeamsCache: Team[] = [];

  // Of that entity's teams, only the ones the assigner may hand out. With no
  // teams of their own (owner, admin) the whole list is theirs to give.
  //
  // Recomputed only when partialTeams itself changes: ng-select tracks [items]
  // by reference, and handing it a fresh array on every change detection cycle
  // makes it rebuild and drop the selection being made.
  get assignableTeams(): Team[] {
    if (this.partialTeams !== this.assignableTeamsSource) {
      this.assignableTeamsSource = this.partialTeams;
      this.assignableTeamsCache = this.partialTeams.filter(team => this.teamScope.isInScope(team.id));
    }
    return this.assignableTeamsCache;
  }
  horizonsTeams: HorizonsTeam[] = [];

  utils = utils;

  entity!: Entity;
  locatedBellow!: string;
  reactiveToRole = 1;
  childEntities!: Entity[];
  entityFormRoleIdLstnr: Subscription = new Subscription;
  entityFormEntityIdLstnr: Subscription = new Subscription;
  entityFormProfileIdLstnr: Subscription = new Subscription;
  teamsLstnr: Subscription = new Subscription;


  selectedHorizonsTeam!: number | null;
  selectedTeam!: number | null;
  selectedProfile: string | null = '1';

  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Input() selectorVisible!: boolean;
  persistEntityId!: number | null;

  constructor(
    public configSvc: ConfigService,
    private formBuilder: FormBuilder,
    public router: Router,
    private userService: UserService,
    private entityService: EntityService,
    private loginService: LoginService,
    private location: Location
  ) {
    if (this.user) this.user.childEntities = this.configSvc.currentConfigValue.childEntities;
    if (this.currentUser) this.currentUser.childEntities = this.configSvc.currentConfigValue.childEntities;
    this.childEntities = this.configSvc.currentConfigValue.childEntities!;
    if (this.action === 'create') this.selectorVisible = true;
  }

  ngOnInit() {
    if (!this.user) {

      if (this.router.url.includes('settings')) {
        this.action = 'detail';

        this.userService.getUserDetail(utils.localStorageGetItem('user')).subscribe(user => {
          this.user = user;
          this.ngAfterViewInit();
        })
      } else {
        this.action = 'create';
        this.user = { 
          id: 0,
          roleId: 0,
          profileId: 1,
          entityId: this.currentUser.entityId,
          teamId: 0,
          horizonsTeamId: 0
        } as User;
      }
    } else {
      this.action = 'edit';
    }

    if (this.action === 'create') {
      this.reactiveToRole = (this.action == 'create' ? this.currentUser.role!.id : 2);
      this.userForm.get('roleId')?.setValue((this.currentUser.roleId + 1).toString())
    }

    if (this.action === 'detail') {
      this.entityService.index({ perPage: -1 }).subscribe(entities => this.entities = entities.data);
    } else {
      this.setParents();
      //this.entityService.getOnlyParents().subscribe(entities => this.entities = entities.data);
    }

    this.entityFormEntityIdLstnr = this.userForm.controls.entityId.valueChanges.subscribe(value => {

      if (!this.teams.length && this.userForm.controls.entityId?.value && ([2, 3, 4].includes(this.user?.roleId) || (this.action === 'create' && ['2', '3', '4'].includes(this.userForm.controls.roleId.value)))) {
        this.setTeams();
      } else {
        this.partialTeams = this.teams.filter((team: Team) => team.entity.id == value);
      }
      if (!this.horizonsTeams.length && this.currentUser.roleId === 1 && (this.user?.roleId === 1 || (this.action === 'create' && this.userForm.controls.roleId.value <= '2'))) {
        this.setHorizonsTeams();
      }
      const childs: Entity[] = this.currentUser.childEntities!;
      const childsUserEntity: Entity[] = this.currentUser.childEntities!.concat(this.configSvc.currentConfigValue!.userEntity!);
      const entityMatched = this.user?.roleId === 1 ? childs!.find((child: Entity) => child.id == Number(value)) : childsUserEntity!.find((child: Entity) => child.id == Number(value));
      if (entityMatched) {
        this.userForm.controls.roleId.patchValue(entityMatched.entityTypeId.toString())
        switch (entityMatched!.entityTypeId) {
          case 1:
            this.setHorizonsTeams();
            break;
          case 2:
            break;
          case 3:
            this.head_office_herency_team = entityMatched?.team?.name!;
            this.userForm.controls.teamId.patchValue(entityMatched!.team?.id!);
            break;
          case 4:
            const parentEntity: Entity = this.childEntities.find((e: Entity) => e.id === entityMatched.parentEntityId)!;
            this.head_office_herency_team = entityMatched?.team?.name!;
            this.userForm.controls.teamId.patchValue(entityMatched!.team?.id!);
            break;
          default:
            this.head_office_herency_team = null;
            this.selectedTeam = null;
            this.userForm.controls.teamId.patchValue(0);
            break;
        }
      } else {
        this.userForm.controls.roleId.patchValue(this.currentUser.roleId.toString());
      }

      this.userForm.controls.horizonsTeamId.patchValue(this.user?.horizonsTeam?.id! ?? 0);
      if (value !== this.user?.entityId) this.userForm.controls.teamId.patchValue(0)
      else (this.selectedTeam = this.user?.teamId! ?? 0, this.userForm.controls.teamId.patchValue(this.user?.teamId! ?? 0));
      //this.selectedProfile = null;

      if (this.currentUser.roleId !== 1 && entityMatched?.entityTypeId == 2 && this.action !== 'create') {
        this.setTeams();
        const matchTeam: Team | undefined = this.teams.find((t: Team) => t.id === this.user.teamId);
        // if(matchTeam) (alert(matchTeam.name),this.head_office_herency_team =matchTeam.name)
        if (matchTeam) (this.selectedTeam = matchTeam.id, this.userForm.controls.teamId.patchValue(matchTeam.id))
        else (this.selectedTeam = 0, this.userForm.controls.teamId.patchValue(0));

        /*if (matchTeam && this.currentUser.teamId && this.currentUser.teamId === this.user.teamId) {
          this.head_office_herency_team = matchTeam!.name
        }*/
      } else if (this.action === 'create') {
        this.selectedTeam = 0; this.userForm.controls.teamId.patchValue(0);
      }
    })

    // Clear horizonsTeam/team when owner profile is combined with admin/distributor roles
    this.entityFormProfileIdLstnr = this.userForm.controls.profileId.valueChanges.subscribe(() => {
      this.checkAndClearOwnerTeams();
    });

    this.entityFormRoleIdLstnr = this.userForm.controls.roleId.valueChanges.subscribe(() => {
      if (this.action === 'create' || this.action === 'edit') {
      this.checkAndClearOwnerTeams();

      // Reset profile to default (1 - editor) when role changes during user creation and modification
      this.userForm.controls.profileId.patchValue('1', { emitEvent: false });
      this.selectedProfile = '1';
      }
    });
  }

  ngAfterViewInit() {
    if (this.user && this.user.id !== 0) {
      this.userForm.patchValue({
        id: this.user.id?.toString(),
        fullname: this.user.fullname,
        email: this.user.email,
        username: this.user.username,
        entityId: this.user.entity.id,
        roleId: this.user.role?.id.toString(),
        profileId: this.user.profile.id?.toString(),
        horizonsTeamId: this.user.horizonsTeam?.id ?? 0,
        teamId: this.user.team?.id ?? 0,
        // The form is what gets saved: opening it without the memberships would
        // send an empty list and strip them.
        teamIds: (this.user.teams ?? []).map(team => team.id),
      });
      this.selectedHorizonsTeam = this.user?.horizonsTeam?.id! ?? 0
      this.selectedTeam = this.user?.team?.id! ?? 0;
      this.selectedProfile = this.user?.profile.id!.toString();
      this.entity = this.childEntities.find((item: Entity) => item.id == this.user?.entity.id)!;
    } else {
      this.selectedHorizonsTeam = this.user?.horizonsTeam?.id! ?? 0
      this.selectedTeam = this.user?.team?.id! ?? 0;
      this.userForm.patchValue({
        entityId: this.currentUser.entityId,
        teamId: 0,
        horizonsTeamId: 0,
        roleId: this.currentUser.roleId.toString()
      });
    }

    // Disable form for view-only users (profileId = 2)
    // Also disable if Editor is trying to edit users from same entity
    if (this.currentUser.profileId === 2 ||
        (this.currentUser.profileId === 1 && this.action === 'edit' && this.user.entityId === this.currentUser.entityId)) {
      this.userForm.disable();
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltipTrigger => new window['bootstrap' as keyof typeof window].Tooltip(tooltipTrigger));
  }

  setTeams = () => {
    if (!this.configSvc.currentConfigValue.teams) {
      this.userService.getTeams({ perPage: -1 }).pipe(map(res => {
        this.teams = res.data;
        this.configSvc.setConfigParamsValue('teams', res.data);
      })).subscribe(res => {
        this.partialTeams = this.teams.filter((team: Team) => team.entity.id == Number(this.userForm.controls.entityId.value));
      });
      this.userForm.get('teamId')?.updateValueAndValidity();
    }
    else {
      this.teams = this.configSvc.currentConfigValue.teams;
      this.partialTeams = this.teams.filter((team: Team) => team.entity.id == Number(this.userForm.controls.entityId.value));
      this.userForm.get('teamId')?.updateValueAndValidity();
    }

  }

  setHorizonsTeams = () => {

    if (!this.configSvc.currentConfigValue.horizonsTeams) {
      this.userService.getHorizonsTeams({ perPage: -1 }).subscribe(horizonsTeams => {
        this.horizonsTeams = horizonsTeams.data;
        this.configSvc.setConfigParamsValue('horizonsTeams', horizonsTeams.data);
        this.userForm.get('horizonsTeamId')?.setValidators(Validators.required);
        this.userForm.get('horizonsTeamId')?.updateValueAndValidity();
      });
    }
    else {
      this.horizonsTeams = this.configSvc.currentConfigValue.horizonsTeams;
      this.userForm.get('horizonsTeamId')?.setValidators(Validators.required);
      this.userForm.get('horizonsTeamId')?.updateValueAndValidity();
    }
  }

  ngOnChanges(change: SimpleChange) {
    this.selectorVisible && !this.persistEntityId
      ? this.persistEntityId = this.userForm.controls.entityId.value
      : null;
    this.userForm.controls.entityId.patchValue(this.user.entityId);
    this.userForm.controls.profileId.patchValue(this.user.profile.id?.toString());
    this.selectedProfile = this.user.profile.id?.toString();
  }

  ngOndestroy() {
    this.entityFormRoleIdLstnr.unsubscribe();
    this.entityFormEntityIdLstnr.unsubscribe();
    this.entityFormProfileIdLstnr.unsubscribe();
    this.teamsLstnr.unsubscribe();
  }

  checkAndClearOwnerTeams() {
    const roleId = this.userForm.controls.roleId.value;
    const profileId = this.userForm.controls.profileId.value;

    // If profile is 3 (owner), clear and disable horizonsTeam
    if (profileId === '3') {
      this.userForm.controls.horizonsTeamId.patchValue(0);
      this.selectedHorizonsTeam = 0;
      this.userForm.get('horizonsTeamId')?.clearValidators();
      this.userForm.get('horizonsTeamId')?.updateValueAndValidity();
    } else if (roleId === '1') {
      // For other admin profiles, restore the required validator
      this.userForm.get('horizonsTeamId')?.setValidators(Validators.required);
      this.userForm.get('horizonsTeamId')?.updateValueAndValidity();
    }

    // If role is 2 (distributor) and profile is 3 (owner), clear and disable team
    if (roleId === '2' && profileId === '3') {
      this.userForm.controls.teamId.patchValue(0);
      this.selectedTeam = 0;
      // The server refuses an owner that still holds memberships, so clear both.
      this.userForm.controls.teamIds.patchValue([]);
    }
  }

  /**
   * Only one of the two team fields travels. A distributor account sends the whole
   * membership and lets the server work out the principal; every other role keeps
   * sending the single team exactly as before.
   */
  private buildPayload(): User {
    const payload = { ...this.userForm.value } as unknown as User;

    if (this.userForm.controls.roleId.value === '2') {
      delete (payload as Partial<User>).teamId;
    } else {
      delete (payload as Partial<User>).teamIds;
    }

    return payload;
  }

  save() {
    this.userForm.markAllAsTouched();
    if (this.userForm.valid) {
      if (this.action === 'create') {
        if (this.currentUser.roleId !== 1 && this.currentUser.teamId && this.userForm.controls.roleId.value === '2') {
          this.userForm.controls.teamId.patchValue(this.currentUser.teamId)
        }
        this.userService.createUser(this.buildPayload()).subscribe(res => {
          this.router.navigate(['users']);
        });
      } else if (this.action === 'edit' || this.action === 'detail') {
        delete this.userForm.value.username
        const propsPossibleEmpty = ['teamId', 'horizonsTeamId'];
        this.userService.updateUser(this.buildPayload(), propsPossibleEmpty).subscribe(res => {
          this.callback.emit({ action: 'updated', result: res });
          if (this.router.url.includes('settings')) {
            this.user.horizonsTeamId = this.userForm.controls.horizonsTeamId.value!;
            this.user.horizonsTeam = this.configSvc.currentConfigValue.horizonsTeams?.find((ho: HorizonsTeam) => ho.id === this.user.horizonsTeamId)
            utils.localStorageSetItem('user', this.user);
            this.configSvc.setConfigParamsValue('user', this.user);
            this.loginService.userStore.next(this.user);
          }
          //this.reload.emit();
        });
      }
    }
  }

  delete() {
    this.userService.deleteUser(this.user.id).subscribe(res => {
      this.reload.emit();
    });
  }

  cancel() {
    if (this.action === 'create') {
      this.location.back();
      this.router.navigate(['/users/']);
    } else {
      //this.reload.emit();
      this.setForm();
    }
  }

  setForm = () => {
    this.userForm.setValue({
      id: String(this.user.id),
      fullname: String(this.user.fullname ?? ''),
      email: String(this.user.email ?? ''),
      username: String(this.user.username ?? ''),
      entityId: this.user.entityId ?? '',
      roleId: String(this.user.roleId ?? ''),
      profileId: this.user.profileId.toString(),
      teamId: this.user.teamId,
      horizonsTeamId: this.user.horizonsTeamId ?? 0,
      teamIds: (this.user.teams ?? []).map(t => t.id),
    });
  }

  changePassword() {
    this.loginService.passwordForgotten(this.user.email).subscribe(res =>{
       utils.toogleGenericModal('#confirmationModal-commonMessage', false);
    })
  }

  setParents() {
    this.entities = this.configSvc.currentConfigValue.childEntities!;
  }

  onChange(id: number, _type?: string) {
    switch (_type) {
      case 'entity':
        this.userForm.controls.entityId.patchValue(id);
        break;
      default:
        break;
    }
  }

}
